import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators'
import { login, logout, getInfo, getUnhandler, organizeLoginVos, organizeUserInfo, organizeLogout } from '@/api/user'
import { campusList } from '@/api/yuansuo/campus'
import { organizeCampusList } from '@/api/institution/campus'
import { getToken, setToken, getOrganizeId, setOrganizeId, getCampusId, setCampusId, removeToken, setOrganizeType, getOrganizeType } from '@/utils/cookies'
import { setStore, getStore } from '@/utils'
import store from '@/store'
import md5 from 'js-md5'
import { Campus } from '@/shims-global'

export interface IUserState {
  token: string
  name: string
  avatar: string
  userInfo: object,
  organizeId: number|string,
  campusId: number|string,
  campus: any, // 当前校区
  campusList: object[], // 所属校区
  roles: string[],
  accesses: object[],
  stayList: object[],
  organizeType: any
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public token = getToken() || ''
  public name = ''
  public avatar = ''
  public userInfo: any = { id: '' }
  public organizeId: number | string = parseInt(<string>getOrganizeId()) || 0
  public campusId: number | string = parseInt(<string>getCampusId()) || 0
  public campus: Campus = { name: '', origin: 0 }
  public campusList = []
  public roles = []
  public accesses: object[] = []
  public stayList: object[] = JSON.parse(getStore('stayList')) || []
  public organizeType = null

  @Mutation
  private SET_TOKEN(token: string) {
    this.token = token
    setToken(token)
  }
  @Mutation
  private SET_STAY_LIST(list: Array<any>) {
    console.log(list)
    this.stayList = list
    // setStayList(list)
    setStore('stayList', list)
  }

  @Mutation
  private SET_NAME(name: string) {
    this.name = name
  }

  @Mutation
  private SET_AVATAR(avatar: string) {
    this.avatar = avatar
  }

  @Mutation
  private SET_USER_INFO(data: object) {
    this.userInfo = data
  }
  @Mutation
  private SET_ORGANIZE_ID(id:number|string) {
    this.organizeId = id
    setOrganizeId(id)
  }
  @Mutation
  private SET_CAMPUS_ID(id:number|string) {
    this.campusId = id
    setCampusId(id)
  }
  @Mutation
  private SET_CAMPUS(data:any) {
    this.campus = data
  }
  @Mutation
  private SET_CAMPUS_LIST(array:[]) {
    this.campusList = array
  }
  @Mutation
  private SET_ACCESSES(arr: object[]) {
    this.accesses = arr
  }

  @Mutation
  private SET_ORGANIZETYPE(data: any) {
    this.organizeType = data
    setOrganizeType(data)
  }
  @Mutation
  private SET_ADD_ROUTES(arr: object[]) {
    // this.addRoutes = arr
  }

  @Action
  public async Login(userInfo: { username: string, password: string }) {
    let { username, password } = userInfo
    username = username.trim()
    password = md5(password)
    const { data } = await organizeLoginVos({ username, password })
    // this.SET_TOKEN(data.token)
    // this.SET_ORGANIZE_ID(data.organizeId)
    // this.SET_CAMPUS_ID(data.campusId || data.id)
    // window.location.reload()
  }
  @Action
  public async CaptchaLogin(userInfo: { username: string, captcha: string }) {
    let { username, captcha } = userInfo
    username = username.trim()
    const { data } = await organizeLoginVos({ username, captcha })
    // this.SET_TOKEN(data.token)
    // this.SET_ORGANIZE_ID(data.organizeId)
    // this.SET_CAMPUS_ID(data.campusId || data.id)
  }
  @Action
  public async getUnhandlerList() {
    try {
      const { data } = await getUnhandler({})
      this.SET_STAY_LIST(data.array)
    } catch (err) {
      console.log(err)
    }
  }

  @Action
  public SetToken(token:string) {
    this.SET_TOKEN(token)
  }

  @Action
  public ResetToken() {
    removeToken()
    this.SET_TOKEN('')
  }

  @Action({ rawError: true })
  public async GetUserInfo() {
    if (this.token === '') {
      throw Error('GetUserInfo: token is undefined!')
    }
    const { data } = await getInfo()
    if (!data) {
      throw Error('Verification failed, please Login again.')
    }
    const { name, avatar, routers } = data
    this.SetAppInfo(data)
  }

  @Action({ rawError: true })
  public async GetOrganizeUserInfo() {
    if (this.token === '') {
      throw Error('GetUserInfo: token is undefined!')
    }
    const { data } = await organizeUserInfo()
    if (!data) {
      throw Error('Verification failed, please Login again.')
    }
    const { name, avatar, routers } = data
    this.SetAppInfo(data)
  }
  @Action
  public async OrganizeLogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!')
    }
    await organizeLogout()
    removeToken()
    this.SET_TOKEN('')
    this.SET_ACCESSES([])
  }
  @Action
  public async LogOut() {
    if (this.token === '') {
      throw Error('LogOut: token is undefined!')
    }
    await logout()
    removeToken()
    this.SET_TOKEN('')
    this.SET_ACCESSES([])
  }
  @Action
  public async FELogOut() {
    removeToken()
    this.SET_TOKEN('')
    this.SET_ORGANIZE_ID('')
    this.SET_CAMPUS_ID('')
    this.SET_ACCESSES([])
  }
  @Action
  public SetAppInfo(data: any) {
    this.SET_TOKEN(data.token)
    this.SET_NAME(data.name)
    // this.SET_AVATAR(data.avatar)
    this.SET_USER_INFO(data)
    this.SET_ORGANIZE_ID(data.organizeId)
    this.SET_CAMPUS_ID(data.campusId || data.id)
    this.SET_ACCESSES(data.accesses || [])

    // // 没有缓存当前校区时 设置第一项 为当前校区
    // if (!getCampusId() && data.campuses && data.campuses.length) {
    //   this.SET_CAMPUS_ID(data.campuses[0].id)
    // }
    data.campuses.map((item:any) => {
      if (item.id === data.campusId) {
        this.SET_CAMPUS(item)
      }
    })
  }
  @Action
  public SetCurrentCampus(data: any) {
    this.SET_CAMPUS_ID(data.id)
    this.SET_CAMPUS(data)
  }
  @Action
  public async SetCampusList(isUpdate: boolean) {
    if (!this.campusList.length || isUpdate) {
      const organizeType = getOrganizeType()
      if (organizeType === 101) {
        const { data } = await campusList()
        this.SET_CAMPUS_LIST(data.array)
      } else if (organizeType === 102) {
        const { data } = await organizeCampusList()
        this.SET_CAMPUS_LIST(data.array)
      }
    }
  }
}

export const UserModule = getModule(User)
